import 'css-chunksrc/client/scenes/taskStatuses/statuses/styles.scss';export default {
  "statuses": "_statuses_hviu1_1",
  "section": "_section_hviu1_5",
  "form": "_form_hviu1_9",
  "title": "_title_hviu1_13",
  "list": "_list_hviu1_20",
  "icon": "_icon_hviu1_24",
  "addStatus": "_addStatus_hviu1_30"
};